import dayjs from 'dayjs/esm';
import type { AncDatePickerValue } from '../anc-date-picker/anc-date-picker.models';

/**
 * The calendar day a picker value represents. Formats a dayjs value through itself so its
 * UTC mode is respected: ngx-daterangepicker emits `.utc(true)` bounds (the picked day's
 * wall-clock time flagged as UTC), and re-reading those as a local Date shifts them a day
 * in any timezone that is not UTC+0.
 */
function toCalendarDay(value: unknown): string {
    if (dayjs.isDayjs(value)) {
        return value.format('YYYY-MM-DD');
    }
    if (value && typeof value === 'object' && typeof (value as { format?: unknown }).format === 'function') {
        return (value as { format(f: string): string }).format('YYYY-MM-DD');
    }
    return dayjs(value as Date).format('YYYY-MM-DD');
}

/** Formats picker range to API `created_at` (`YYYY-MM-DD,YYYY-MM-DD`, both days inclusive). */
export function formatAncCreatedAtFilter(range: AncDatePickerValue): string | null {
    if (range?.startDate == null || range?.endDate == null) {
        return null;
    }
    const start = toCalendarDay(range.startDate);
    const end = toCalendarDay(range.endDate);
    return `${start},${end < start ? start : end}`;
}
